export enum CallTableSortColumnEnum {
    DateTime = "DateTime",
    FirstParty = "FirstParty",
    SecondParty = "SecondParty",
    Duration = "Duration",
    Comment = "Comment",
    Outcome = "Outcome"
}

